<template>
  <div class="sy">
    <div class="rule" @click="showModel"></div>
    <div class="time"></div>
    <div class="card1">
      <div class="tText">点金积分11000</div>
      <div class="bText">可兑换价值10元积分商城礼品</div>
      <div class="btn" @click="getIntegral"></div>
    </div>
    <div class="card2">
      <div class="title1">元益多</div>
      <div class="title2">元添利</div>
      <div class="title3">鑫益多</div>
      <div class="btn3" @click="goyyd"></div>
      <div class="btn4" @click="goytl"></div>
      <div class="btn5" @click="goxyd"></div>
      <div class="num1">
        <span>6.6</span>%
      </div>
      <div class="bnum1">预期年化收益率</div>
      <div class="num2">
        <span>6.0</span>%
      </div>
      <div class="bnum2">到期年化收益率</div>
      <div class="num3">
        <span>3.1</span>%-<span>3.6</span>%
      </div>
      <div class="bnum3">预期年化收益率 </div>
      <div class="ts1">14天</div>
      <div class="ts2">21天</div>
      <img class="ts3" src="../assets/img/12.png" alt="">
      <!-- <div class="ts3">半年一年、三年期</div> -->
      <div class="tsText1">限额5万元</div>
      <div class="tsText2">1千元-3万元</div>
      <!-- <div class="tsText3">起点：5万元</div> -->
    </div>
    <div class="card3">
      <div class="tText">Level2行情</div>
      <div class="bText">十档行情&nbsp;&nbsp;洞察主力&nbsp;&nbsp;快人一步&nbsp;&nbsp;博弈资金</div>
      <div class="btn2" @click="getCoupon"></div>
    </div>
    <van-action-sheet v-model="show">
      <div class="model">
        <div class="close" @click="closeModel"></div>
        <div class="title">活动规则</div>
        <p>
          <span>活动时间：</span>2022年1月1日—2022年12月31日
        </p>
        <p>
          <span>活动规则：</span>
        </p>
        <p>
          <span>1、</span>活动期间，在国元证券新开账户（包括新开立资金账户和沪、深A股证券账户）、开通三方存管、注册国元点金APP的客户，完成相应动作，可获赠点金积分、新客理财、level2行情等大礼包，礼包内容如下：
        </p>
        <div class="img"></div>
        <p>
          <span>活动注意事项：</span>
        </p>
        <p>
          <span>1、礼包领取条件：</span>客户在活动期间，在国元证券新开立沪、深A股证券账户和资金账户、三方存管，并注册国元点金，进入国元点金APP活动页面，点击领取相应礼包；
        </p> 
        <!-- <p>
          <span>2、</span>客户手机号码必须与开户时留存的手机号码保持一致,完成相应动作，积分自动到账；
        </p>-->
         <p>
          <span>2、积分兑换：</span>客户可登录国元点金APP，在“我的”-“我的积分”查看及使用，积分可用于积分商城兑换、消费。活动涉及宣传图片仅为仅为积分商城礼品展示，具体商品积分兑换标准以积分商城例示为准；
        </p>
        <p>
          <span>3、新客理财产品：</span>两个新客理财产品不可同时购买，有效期为开户成功后的30个自然日内；
        </p>
        <p>
          <span>4、level2 行情体验券：</span>可免费兑换一个季度level2行情体验券，并在使用前抵扣。Level2行情体验劵有效期为3个月。
        </p>
        <p>
          <span>5、风险提示：</span>客户领取优惠券进行产品和服务兑换时，请认真阅读产品相关协议；页面涉及到的理财产品收益皆为估算，不构成任何投资建议，实际收益请以合同约定和实际到账金额为准。
        </p>
        <p>
          <span>6、</span>本次活动最终解释权归国元证券所有。
        </p>
      </div>
    </van-action-sheet>
    <div class="textEnd">投资有风险，入市需谨慎。</div> 
  </div>
</template>

<script>
import { openService } from "@/utils/common";
// import Swiper from "swiper" ;

// import CryptoJS from "crypto-js";
import {
  pageBuryingPoint,
  eventBuryingPoint,
  DestructyBuryingPoint
} from "@/utils/BuryingPoint";
import fetch from "@/utils/fetch";
import { showToast, pageRecord, showLoading, hideLoading } from "@/utils/h5";
import Decrypt from "@/utils/copy";

export default {
  name: "HomePage",
  data() {
    return {
      subCode: "xhzx_lottery",
      sbCode:'',//设备码
      commonCode: "xhzx_lottery",
      loginFlag: this.$root.loginFlag, //登陆状态
      accountNo: "",
      actFlag: null, //活动状态 1活动进行中 2活动未开始 3 活动已结束
      fundLoginFlag: false, //资金账号登录
      num: 1, //跳转记录页
      key: this.$root.key,
      time: true,
      toast: "",
      status: 0,
      show: false
    };
  },
  created() {
    this.init();
  },
  mounted() {
    // this.$refs.mySwiper.swiper.slideNext();
    // console.log(this.$refs.mySwiper.$swiper.allowSlide, "yiohhiuh");
  },

  beforeDestroy() {
    //页面销毁前
    DestructyBuryingPoint("p_ytwxxhzxsy_01");
  },
  methods: {
    closeModel() {
      this.show = false;
    },
    showModel() {
      this.show = true;
    },
    goyyd(num) {
      let that = this;
      that.status = 2;
      let eventName = "l_ytwxxhzxyyd_01";
      if (that.$root.channel == "qita") {
        //其他
        window.location.href = "http://www.gyzq.com.cn/gyzq/gydj/gydj.html";
        return;
      }
      if (that.fundLoginFlag) {
        // // let param = {
        // //   webUrl:
        // //     "http://60.174.200.97:48081/wxfw/resource/activity/2021/zxhd/index.html"
        // // };

        // // 跳转埋点
        that.getInfo();
        eventBuryingPoint("c_ytwxyx_01", eventName);

        // openService("BANNER", "3", "KDS_WebPageWithHead", param);
      } else {
        // 未登录
        if (that.$root.channel == "gydj") {
          if (num == 1) {
          } else {
            //在点金中
            that.handleAccountNO("hqxx"); //跳转登录页
            openService("", "3", "FN_H5_PTJY_Login", "");
          }
        }
      }
    },

    goytl(num) {
      let that = this;
      that.status = 3;
      let eventName = "l_ytwxxhzxytl_01";
      if (that.$root.channel == "qita") {
        //其他
        window.location.href = "http://www.gyzq.com.cn/gyzq/gydj/gydj.html";
        return;
      }
      if (that.fundLoginFlag) {
        // let param = {
        //   webUrl:
        //     "http://60.174.200.97:48081/wxfw/resource/activity/2021/zxhd/index.html"
        // };

        // 跳转埋点
        that.getInfo();
        eventBuryingPoint("c_ytwxyx_01", eventName);

        // openService("BANNER", "3", "KDS_WebPageWithHead", param);
      } else {
        // 未登录
        if (that.$root.channel == "gydj") {
          if (num == 1) {
          } else {
            //在点金中
            that.handleAccountNO("hqxx"); //跳转登录页
            openService("", "3", "FN_H5_PTJY_Login", "");
          }
        }
      }
    },

    goxyd(num){
      let that = this;
      that.status = 5;
      let eventName = "l_ytwxxhzxxyd_01";
      if (that.$root.channel == "qita") {
        //其他
        window.location.href = "http://www.gyzq.com.cn/gyzq/gydj/gydj.html";
        return;
      }
      if (that.fundLoginFlag) {
        // let param = {
        //   webUrl:
        //     "http://60.174.200.97:48081/wxfw/resource/activity/2021/zxhd/index.html"
        // };

        // 跳转埋点
        that.getInfo();
        eventBuryingPoint("c_ytwxyx_01", eventName);

        // openService("BANNER", "3", "KDS_WebPageWithHead", param);
      } else {
        // 未登录
        if (that.$root.channel == "gydj") {
          if (num == 1) {
          } else {
            //在点金中
            that.handleAccountNO("hqxx"); //跳转登录页
            openService("", "3", "FN_H5_PTJY_Login", "");
          }
        }
      }
    },

    getIntegral(num) {
      var that = this;
      that.status = 1;
      let eventName = "l_ytwxxhzxljf_01";
      if (that.$root.channel == "qita") {
        //其他
        window.location.href = "http://www.gyzq.com.cn/gyzq/gydj/gydj.html";
        return;
      }
      if (that.fundLoginFlag) {
        that.getInfo();
        eventBuryingPoint("c_ytwxyx_01", eventName);
      } else {
        // 未登录
        if (that.$root.channel == "gydj") {
          if (num == 1) {
          } else {
            //在点金中
            // that.handleRegister("level"); //跳转登录页
            // openService("", "3", "KDS_Register", "");
            that.handleAccountNO("hqxx"); //跳转登录页
            openService("", "3", "FN_H5_PTJY_Login", "");
          }
        }
      }
    },

    getCoupon(num) {
      var that = this;
      that.status = 4;
      let eventName = "l_ytwxxhzxlyhq_01";
      if (that.$root.channel == "qita") {
        //其他
        window.location.href = "http://www.gyzq.com.cn/gyzq/gydj/gydj.html";
        return;
      }
      if (that.fundLoginFlag) {
        that.getInfo();
        eventBuryingPoint("c_ytwxyx_01", eventName);
      } else {
        // 未登录
        if (that.$root.channel == "gydj") {
          if (num == 1) {
          } else {
            //在点金中
            // that.handleRegister("level"); //跳转登录页
            // openService("", "3", "KDS_Register", "");
            that.handleAccountNO("hqxx"); //跳转登录页
            openService("", "3", "FN_H5_PTJY_Login", "");
          }
        }
      }
    },

    // 获取信息
    getInfo(num) {
      fetch
        .post("/xhzx/info", {
          subCode: this.subCode,
          deviceId:this.sbCode
        })
        .then(res => {
          if (res.code == 10000) {
            if (res.data.type == 1) {
              if (this.status == 1) {
                if (res.data.integralStatus == 1) {
                  this.getIntegralOrCoupon();
                  let param = {
                    webUrl: "http://wx.gyzq.com.cn/jfsc/appMh/#/home",
                    loginType: 3
                  };

                  openService("BANNER", "3", "KDS_WebPageWithHead", param);
                } else if (res.data.integralStatus == 2) {
                  let param = {
                    webUrl: "http://wx.gyzq.com.cn/jfsc/appMh/#/home",
                    loginType: 3
                  };

                  openService("BANNER", "3", "KDS_WebPageWithHead", param);
                  return;
                } else if (res.data.integralStatus == 3) {
                  showToast({
                    message: "您已领取客户邀约活动积分奖励。",
                    duration: 2000
                  });
                }
              } else if (this.status == 4) {
                if (res.data.couponStatus == 1) {
                  this.getIntegralOrCoupon();
                  let param = {
                    webUrl: {
                      startUPAdv: "12",
                      funId: "0",
                      exkey: "caae869c825cab91b22e41509dbae29b",
                      url: "GYDJL://kds519iew/common/level2/funcIntro.html"
                    }
                  };

                  openService("", "2", "FN_SM_TGLive", param);
                } else {
                  let param = {
                    webUrl: {
                      startUPAdv: "12",
                      funId: "0",
                      exkey: "caae869c825cab91b22e41509dbae29b",
                      url: "GYDJL://kds519/view/common/level2/funcIntro.html"
                    }
                  };

                  openService("", "2", "FN_SM_TGLive", param);
                  return;
                }
              } else if (this.status == 2) {
                let Url1 = Decrypt(res.data.url1);
                console.log(Url1);
                let param = {
                  webUrl: Url1
                };

                openService("BANNER", "3", "KDS_WebPageWithHead", param);
              } else if (this.status == 3) {
                let Url2 = Decrypt(res.data.url2);
                console.log(Url2);
                let param = {
                  webUrl: Url2
                };

                openService("BANNER", "3", "KDS_WebPageWithHead", param);
              } else if (this.status == 5){
                 fetch
                .post("/wxyx/config", {
                  subCode: 'xhzx_lottery',
                  key: 'XYD'
                })
                .then(res => {
                  if (res.code == 10000) {
                    let Url3 = res.data
                    console.log(Url3);
                    let param = {
                      webUrl: Url3
                    };

                    openService("BANNER", "3", "KDS_WebPageWithHead", param);
                  }else if (res.code == 10033) {
                    showToast({ message: res.msg, duration: 2000 });
                  } else if (res.code == 10034) {
                    showToast({ message: res.msg, duration: 2000 });
                  }
                });
              }
            } else if (res.data.type == 2) {
              showToast({
                message:
                  "您不符合参与条件！请核对活动参与规则，或与客户经理联系。",
                duration: 2000
              });
            } else if (res.data.type == 3) {
              if (
                this.status == 1 ||
                this.status == 2 ||
                this.status == 3 ||
                this.status == 4
              ) {
                return showToast({
                  message: "您已参加新户专享大礼包活动，不可重复参与。",
                  duration: 2000
                });
              }
            } else if (res.data.type == 4) {
              showToast({
                message: "当前手机领奖数已超上限，请更换手机再试。",
                duration: 2000
              });
            }else if (res.data.type == 5) {
              showToast({
                message: "您已参加客户邀约活动",
                duration: 2000
              });
            }
            //列表获取成功
          } else if (res.code == 10033) {
            showToast({ message: res.msg, duration: 2000 });
          } else if (res.code == 10034) {
            showToast({ message: res.msg, duration: 2000 });
          } else {
            showToast({ message: res.msg, duration: 2000 });
          }
        });
    },

    // 获取信息
    getIntegralOrCoupon(num) {
      var that = this;
      let param = "";
      if (that.status == 1) {
        param = "integral";
      } else if (that.status == 4) {
        param = "coupon";
      }
      fetch
        .post("/xhzx/drawLottery", {
          subCode: that.subCode,
          type: param,
          deviceId:that.sbCode
        })
        .then(res => {
          if (res.code == 10000) {
            //列表获取成功
          }else if (res.code == 10033) {
            showToast({ message: res.msg, duration: 2000 });
          } else if (res.code == 10034) {
            showToast({ message: res.msg, duration: 2000 });
          }
        });
    },

    init() {
      var that = this;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("gydj") != -1) {
        that.$root.channel = "gydj";
        window.setOpenState = function(state) {
          var deviceInfo = JSON.parse(state);

          if (deviceInfo.functionCode == "FN_EMBED_H5_USERINFO") {
            console.log(deviceInfo);
            var num = deviceInfo.result.str;
            that.$root.accountNo = num;
            that.checkAccountNo(num);
          }
          if(deviceInfo.functionCode == "FN_EMBED_H5_DEVICEINFO"){
            that.sbCode = deviceInfo.result.str;
          }
        };
        that.getUserInfo(); //获取用户登录信息
        pageBuryingPoint("p_ytwxxhzxsy_01");
      } else {
        // this.$root.channel = "weixin";
        that.$root.channel = "qita";
      }
      pageRecord(that.subCode); //增加页面访问记录
    },

    /**
     * 图片禁止预览
     * @param {Object} e event对象
     */
    handleForbidPreview(e) {
      e.preventDefault() && e.stopPropagation();
    },
    handleRegister: function(type) {
      var that = this;
      window.setOpenState = function(state) {
        var deviceInfo = JSON.parse(state);
        if (deviceInfo.functionCode == "KDS_Register") {
          var ua = window.navigator.userAgent.toLowerCase();
          var State;
          if (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1) {
            State = deviceInfo.state;
          } else if (ua.indexOf("android") > -1) {
            State = deviceInfo.result.state;
          }
          if (+State == 1) {
            //注册成功
            that.getUserInfo(); //验证登录状态
            that.handleRegister(type);
            return;
          }
        }

        if (deviceInfo.functionCode == "FN_EMBED_H5_USERINFO") {
          //获取登录状态
          var num = deviceInfo.result.str;
          that.$set(that, "accountNo", num);
          // if (type == "ksdt") {
          //           that.checkAccountNo(num, that.startAnswer, 1);
          //         } else
          if (type == "hqxx") {
            that.checkAccountNo(num);
          } else {
            that.checkAccountNo(num);
          }
        }
      };
    },
    //获取用户信息
    getUserInfo() {
      var JSONData = {
        mark: "mark",
        key: "OLDmkHpviT4P!34g",
        iv: "!wpgXOqxFt%J99Tb"
      };
      openService("", "5", "FN_EMBED_H5_USERINFO", JSONData);
      openService("", "5", "FN_EMBED_H5_DEVICEINFO", JSONData);
    },
    //跳转资金账号页面
    handleAccountNO(type) {
      var that = this;
      window.setOpenState = function(state) {
        var deviceInfo = JSON.parse(state);
        console.log("deviceInfo", deviceInfo);
        if (deviceInfo.functionCode == "FN_H5_PTJY_Login") {
          var ua = window.navigator.userAgent.toLowerCase();
          var State;
          if (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1) {
            State = deviceInfo.state;
          } else if (ua.indexOf("android") > -1) {
            State = deviceInfo.result.state;
          }
          console.log("资金账号" + State);
          if (+State == 1) {
            //注册成功
            that.getUserInfo(); //验证登录状态
            that.handleAccountNO(type);
            return;
          }
        }
        if (deviceInfo.functionCode == "KDS_Register") {
          var ua = window.navigator.userAgent.toLowerCase();
          var State;
          if (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1) {
            State = deviceInfo.state;
          } else if (ua.indexOf("android") > -1) {
            State = deviceInfo.result.state;
          }
          console.log("注册" + State);
          if (+State == 1) {
            //注册成功
            that.getUserInfo(); //验证登录状态
            that.handleAccountNO(type);
            return;
          }
        }
        if (deviceInfo.functionCode == "FN_EMBED_H5_USERINFO") {
          //获取资金状态
          var num = deviceInfo.result.str;
          // accountNoOld = num;
          that.$set(that, "accountNo", num);
          sessionStorage.setItem("accountNo", num); //资金账号
          console.log("注册手机" + num);
          if (type == "yyd") {
            that.checkAccountNo(num, that.goyyd, 1);
          } else if (type == "ytl") {
            that.checkAccountNo(num, that.goytl, 1);
          } else if (type == "hqxx") {
            that.checkAccountNo(num, that.getInfo, 1);
          } else if (type == "xyd") {
            that.checkAccountNo(num, that.goxyd, 1);
          } else {
            that.checkAccountNo(num);
          }
        }
      };
    },

    //检测是否登录
    checkAccountNo(num, callBack, type) {
      var that = this;
      fetch
        .post("/wxyx/loginApp", {
          // accountNo: num,
          accountNo: num,
          subCode: that.subCode
        })
        .then(res => {
          if (res.code == 10000) {
            let data = res.data;

            if (data.fundState) {
              //资金账号登录
              that.$set(that, "accountNo", num);
              that.$set(that, "fundLoginFlag", true);
              that.$set(that, "loginFlag", true);
              sessionStorage.setItem("accountNo", that.accountNo); //资金账号
            } else if (data.phoneState && !data.fundState) {
              that.$set(that, "accountNo", num);
              that.$set(that, "loginFlag", true);
              that.$set(that, "fundLoginFlag", false);
              sessionStorage.setItem("accountNo", that.accountNo); //资金账号
            } else {
              that.$set(that, "fundLoginFlag", false);
              that.$set(that, "loginFlag", false);
            }
          } else {
            that.$set(that, "fundLoginFlag", false);
          }

          // console.log('check', that.fundLoginFlag);
          if (typeof callBack === "function") {
            let num = type;
            callBack(num);
          }
        });
    },

  }
};
</script>

<style lang="less" scoped>
</style>
